// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 268 ? "aaea2bcf" : chunkId) + "." + {"268":"5884545ce0982058","446":"8d028c5908fa3b51","676":"e93f8f005fd0cddd"}[chunkId] + ".js";
};